import product1 from '../img/product1.jpg';
import product2 from '../img/product2.jpg';

export const inventory = [
    {
        id: 1,
        sku: 'sku_GhmqRa7zJiHUB2',
        image: product1,
        name: 'Apiary Sticker',
        price: 3,
        description: 'The high quality 3" die cut vinyl sticker version of our badge logo for you to put wherever you want. Preferably not the trash. This is the version without the thank you note.'
    },
    {
        id: 2,
        sku: 'sku_GxZEVSe3oxrPQs',
        image: product2,
        name: 'Apiary Sticker with Handwritten Thank You Note',
        price: 5,
        description: 'The high quality 3" die cut vinyl sticker version of our badge logo for you to put wherever you want. Preferably not the trash. Comes with a handwritten thank you note.'
    }
];